import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchMe, requestSms } from "../lib/api";

export default function Login() {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);
  const [phone, setPhone] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setChecking(false);
      return;
    }
    (async () => {
      try {
        await fetchMe();
        navigate("/dashboard", { replace: true });
      } catch {
        setChecking(false);
      }
    })();
  }, [navigate]);

  const handleSms = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      const result = await requestSms(phone);
      navigate("/verify-otp", {
        state: {
          pendingToken: result.pending_token,
          phoneMasked: result.phone_masked,
          smsSent: result.sms_sent,
        },
        replace: true,
      });
    } catch (err) {
      setError(err?.response?.data?.detail || "Numéro non autorisé.");
    } finally {
      setSubmitting(false);
    }
  };

  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <span className="spinner" />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col">
      <div className="strip flex items-center justify-between" data-testid="top-strip">
        <span>Espace Privée</span>
        <span>Internal · Restricted Access</span>
      </div>

      <div className="flex-1 grid lg:grid-cols-12 gap-0">
        <div className="lg:col-span-7 p-8 lg:p-16 flex flex-col justify-between border-r-2 border-[var(--ink)]">
          <div>
            <div className="label mb-6">Console Interne — v1.0</div>
            <h1 className="font-display text-5xl md:text-7xl leading-[0.95] tracking-tighter">
              Les
              <br />
              <span className="bg-[var(--ink)] text-white px-3">entreprises</span>
              <br />
              françaises.
            </h1>
          </div>

          <div className="hidden lg:grid grid-cols-2 gap-6 mt-12 max-w-2xl">
            {[
              ["Périmètre", "France + DOM"],
              ["Rafraîchissement", "30 minutes"],
            ].map(([k, v]) => (
              <div key={k} className="border-l-2 border-[var(--ink)] pl-4">
                <div className="label text-[var(--muted)]">{k}</div>
                <div className="font-display text-2xl mt-1">{v}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-5 p-8 lg:p-16 flex items-center">
          <div className="surface surface-shadow w-full p-8 reveal" data-testid="login-card">
            <div className="label border-b-2 border-[var(--ink)] pb-3 mb-6">
              Identification par SMS
            </div>

            {/* Method B: SMS phone */}
            <form onSubmit={handleSms} data-testid="auth-method-sms">
              <div className="label mb-2">Téléphone autorisé (SMS)</div>
              <input
                type="tel"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="Numéro de téléphone autorisé"
                className="input input-mono border-2 border-[var(--ink)]"
                data-testid="login-phone-input"
                required
              />
              {error && (
                <div className="mt-3 border-2 border-[var(--ink)] bg-[var(--accent)] text-white p-3 text-xs font-mono" data-testid="login-sms-error">
                  {error}
                </div>
              )}
              <button
                type="submit"
                disabled={submitting || phone.length < 9}
                className="btn btn-primary w-full justify-center mt-3"
                data-testid="login-sms-button"
              >
                {submitting ? <span className="spinner" /> : "Recevoir un code par SMS"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
